/**
 *
 * AdditionalColumnsPopup
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 29-Nov-2022
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import PortalModal from 'Components/PortalModal/PortalModalContainer';
import PortalCheckbox from 'Components/PortalCheckbox/PortalCheckbox';
import PortalButton from 'Components/PortalButton';
import { useIntl } from 'react-intl';
import formattedMessages from '../languageModule';
import style from './AdditionalColumnsPopup.scss';

const AdditionalColumnsPopup = (props) => {
  const [checkboxesChecked, setCheckboxesChecked] = useState({});
  const intl = useIntl();

  const onClickHandler = (e) => {
    const { id, value } = e.target;

    if (id && value) {
      //check if an element exists and removes it
      if (checkboxesChecked[id]) {
        const { [id]: _, ...newState } = checkboxesChecked;
        return setCheckboxesChecked(newState);
      }

      const parsedValue = JSON.parse(value);
      setCheckboxesChecked({
        ...checkboxesChecked,
        [id]: parsedValue,
      });
    }
  };

  const onConfirmHandler = () => {
    props.extraHeadersSetter(
      [...new Array(props.extraHeaders.length)].map((_, index) =>
        checkboxesChecked[index] ? checkboxesChecked[index] : null
      )
    );
    props.onCloseModal();
  };

  return (
    <PortalModal className={style.container} open={props.open} title={formattedMessages.addColumns}>
      <Grid className={style.content}>
        {props.extraHeaders.map((extraHeader, index) => (
          <PortalCheckbox
            key={`additional-column-popup-${index}`}
            name={`additional-column-popup-${index}`}
            label={intl.formatMessage(extraHeader)}
            checked={checkboxesChecked[index]}
            onClick={(e) => onClickHandler(e)}
            value={JSON.stringify(extraHeader)}
            id={index}
          />
        ))}
      </Grid>
      <Grid className={style.action}>
        <PortalButton contentText={formattedMessages.confirm} onClick={onConfirmHandler} />
      </Grid>
    </PortalModal>
  );
};

AdditionalColumnsPopup.propTypes = {
  open: PropTypes.bool,
  extraHeadersSetter: PropTypes.func,
  onCloseModal: PropTypes.func,
  extraHeaders: PropTypes.array,
};

AdditionalColumnsPopup.defaultProps = {
  // Add here some default propTypes values
};

export default AdditionalColumnsPopup;
